import { UserPreferences } from '../../user-settings/models/user-preferences.model';

export class SetUserPreferences {
  static readonly type = '[USER PREFERENCES] Set user preferences';

  constructor(public payload: UserPreferences) {
  }
}
